export var WebSocketEventEnum;
(function (WebSocketEventEnum) {
    WebSocketEventEnum["RECEIVED"] = "notification_received";
    WebSocketEventEnum["UNREAD"] = "unread_count_changed";
    WebSocketEventEnum["UNSEEN"] = "unseen_count_changed";
    /** Live agent `AgentEventEnvelope` fan-out over the shared WS bus. */
    WebSocketEventEnum["AGENT_EVENT"] = "agent_event";
})(WebSocketEventEnum || (WebSocketEventEnum = {}));
//# sourceMappingURL=ws.js.map